// angular
import { NgClass } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
// components
import { InputComponent } from '@app/core/components/input/input.component';
// services
import { StateManagementService } from '@app/+chat/shared/services/state-management.service';
import { StorageService } from '@app/shared/services/storage.service';
import { UserService } from '@app/shared/services/user.service';
// utils & constants
import { DialogRef } from '@app/core/shared/utils/dialog/dialog-ref';
import { LanguageCodes } from '@app/shared/constants/language-codes.const';

@Component({
  selector: 'pwj-chat-languages-dialog',
  standalone: true,
  imports: [TranslateModule, NgClass, InputComponent, FormsModule],
  templateUrl: './chat-languages-dialog.component.html',
  styleUrl: './chat-languages-dialog.component.scss',
})
export class ChatLanguagesDialogComponent {
  public languageCodes: {
    language: string;
    lang_iso_code: string;
  }[] = LanguageCodes;
  public currentChatLang!: string;
  public selectedChatLang!: string;
  public searchInput!: string;

  private readonly _stateManagementService = inject(StateManagementService);
  private readonly _storageService = inject(StorageService);
  private readonly _dialogRef = inject(DialogRef);
  private readonly _userService = inject(UserService);

  constructor() {
    this.currentChatLang = this._storageService.getChatLang();
  }

  public onSelectLanguage(languageCode: string) {
    this.selectedChatLang = languageCode;
    // set chat lang in cookie
    this._storageService.setChatLang(languageCode);
    // set chat lang in subject for fetching data
    this._stateManagementService.currentChatLanguage.set(languageCode);
    if (this._storageService.getToken() && (this._userService.userSignal()?.roles?.length || 0) > 0) {
      // update user profile language for sockets
      this._userService.updateProfileLanguage(this.selectedChatLang);
    }
    // close dialog
    this.close();
  }

  // search language functionality
  public onSearchLanguage(event: Event) {
    const searchTerm = event.target as HTMLInputElement;
    const value = searchTerm?.value;

    if (value) {
      const languagesData = LanguageCodes;
      this.languageCodes = languagesData.filter(data =>
        data.language.toLowerCase().includes(value.toLowerCase())
      );
    } else {
      this.languageCodes = LanguageCodes;
    }
  }

  public close() {
    const result = {
      changeLanguage: !!this.selectedChatLang,
    };
    this._dialogRef.close(result);
  }
}
